import * as io from 'io-ts';
import { boolean, nullableNumber } from '@shared/core/types/common';
import { addressProviderEnum } from '@shared/core/types/consts';

const rootDefinition: io.MixedObject<OLO.Config.AddressProvider> = {
    enabled: boolean,
    id: addressProviderEnum,
    searchDistance: nullableNumber,
};

export const addressProviderSchema = io.type(rootDefinition);
